<template>
  <div>
    
    <div v-if="f_field.headline" class="mt-4 mb-3">
      <v-flex style="background-color:#e2e2e2;" class="px-3 py-2 elevation-3 xs12">
        <h3 class="subtitle xs12 flex">
          {{f_field.title}} 
          <v-menu offset-y class="right mb-1">
            <v-btn slot="activator" color="grey lighten-2" small icon class="mt-0 mb-0">
              <v-icon small color="grey lighten-5" >add</v-icon>
            </v-btn>
            <v-list>
              <v-list-tile v-for="item in dynamic_field_list" :key="item.name" @click="add_field(item)">
                <v-list-tile-title>{{ item.title }}</v-list-tile-title>
              </v-list-tile>
            </v-list>
          </v-menu>
        </h3>
        <!-- <v-divider color='black'></v-divider> -->
        </v-flex>
    </div>

    <div v-if="f_field.component" class="mt-2 mb-2 mx-0">
      <v-flex style="background-color:#fafafa;" class="px-3 py-2 elevation-1 xs12">
        <h3 class="subtitle xs12 flex">{{f_field.title}}  ({{count}})
            <v-btn @click="showUpload=!showUpload" color="grey lighten-5" small icon class="right mt-0 mb-0">
              <v-icon v-if="!showUpload" small>expand_more</v-icon>
              <v-icon v-if="showUpload" small dark>expand_less</v-icon>
            </v-btn>
        </h3>
        <component :is="f_field.component" :uploadCategory="f_field.title" :artwork="f_artwork" :name="f_field.name" v-if="showUpload"></component>
        </v-flex>
    </div>
    
    <div v-else>
      <v-flex v-if="field_type=='text-short'">
        <v-flex>
          <label>{{label}}</label>
          
            <!-- :readonly="!isEditing" -->
          <v-text-field class="" solo  
            :name="f_field.name"
            :ref="f_field.name"
            v-model="electrical.production_date"
            :hint="`${f_field.title}`"
            persistent-hint
            :suffix="f_field.suffix"
            @input.native="$emit('input',$event.target.value)"
            append-outer-icon="remove"
            @click:append-outer="removeField(f_field)"
          ></v-text-field>
          <div v-if="an_exists">This accession number already exists!</div>
          <div v-if="saved" class="ml-3">Value was saved!</div>
          <div v-if="cannotSave" class="ml-3">Value already exists! Cannot save!</div>
          <!-- <v-btn icon v-if="f_field.dynamic" class="ml-3">
            <v-icon>remove</v-icon>
          </v-btn> -->

        </v-flex>
      </v-flex>

      <v-flex v-else-if="this.field_type=='text-long'" class="my-0 py-0">
          <!-- :readonly="!isEditing" -->
        <v-textarea class="my-0" auto-grow   solo
          :name="f_field.name"
          :ref="f_field.name"
          rows=1
          :value="`${f_artwork[f_field.name]}`"
          :hint="f_field.title"
          persistent-hint
          append-outer-icon="remove"
          @click:append-outer="removeField(f_field)"
          @input.native="$emit('input',$event.target.value)"
        ></v-textarea>
          <!-- :label="f_field.title" -->
      </v-flex>

      <v-container v-else-if="this.field_type=='date'" grid-list-xs :class="`${f_field.class} my-0 py-0`">
        <v-layout xs12 md6>
          <v-flex xs4>
            <v-text-field solo
              v-model="model"
              type="number"
              mask="####"
              max="2019"
              min="1900"
              :name="f_field.name"
              :ref="f_field.name"
              :value="`${f_artwork[f_field.name]}`"
              label="Year"
              placeholder="Year"
              hint="Year"
              @input.native="$emit('input',$event.target.value)"
            ></v-text-field>
          </v-flex>
          <v-flex xs4>
            <v-text-field solo
              type="number"
              mask="##" 
              max="12"
              :name="f_field.name"
              :ref="f_field.name"
              :value="`${f_artwork[f_field.name]}`"
              label="Month"
              placeholder="Month"
              hint="Month"
              @input.native="$emit('input',$event.target.value)"
            ></v-text-field>
          </v-flex>
          <v-flex xs4>
            <v-text-field solo
              type="number"
              mask="##" 
              max="31"
              :name="name"
              :value="`${f_artwork[f_field.name]}`"
              label="Day"
              placeholder="Day"
              hint="Day"
              @input.native="$emit('input',$event.target.value)"
            ></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout row wrap class="my-0 py-0">
          <v-flex xs12 class="my-0 py-0">
            <label class="my-0 py-0 pl-2">{{f_field.title}}  {{f_artwork[f_field.name]}} </label>
            <v-btn @click="removeField(f_field)" icon v-if="f_field.dynamic" class="ml-3">
              <v-icon>remove</v-icon>
            </v-btn>
                        <!-- append-outer-icon="remove"
            @click:append-outer="removeField(f_field)" -->
          </v-flex>
        </v-layout>
      </v-container>

      <v-flex v-else-if="this.field_type=='bool'" class="pl-4 pr-4">
        <v-switch :v-model="`${f_field.name}`" :label="`${f_field.title}`" color="black"
          append-icon="remove"
          @click:append="removeField(f_field)"
        ></v-switch>
        <!-- <v-btn @click="removeField(f_field)" icon v-if="f_field.dynamic" class="ml-5" style="width:40px;">
          <v-icon>remove</v-icon>
        </v-btn> -->
      </v-flex>

      <v-flex v-else-if="this.field_type=='radio'">
        <v-radio-group :label="`${f_field.title}`" :column="f_field.column ? f_field.column : false" v-model="value_new" :refs="f_field.name"
          append-icon="remove"
          @click:append="removeField(f_field)"
        >
          <!-- @change="updateValue(f_field.name)"  -->
          <v-radio v-for="s in f_field.selection" :label="s.name" :value="s.id" :key="s.id" class="ml-3"></v-radio>
        </v-radio-group>
        <v-flex class="elevation-3 py-3 px-3" v-if="f_field.name=='sound' && this.value_new=='1'">
          <v-flex c>
            <v-text-field v-model="audio_codec" label="Audio Codec" row></v-text-field>
          </v-flex>
          <v-flex v-if="f_field.name=='sound' && this.value_new=='1'">
            <v-radio-group v-model="audio_resolution" label="Audio Resolution" row>
              <v-radio v-for="s in ['32 kHz','44,1 kHz','48 kHz','96 kHz','192 kHz']" :label="s" :value="s" :key="s" class="ml-3"></v-radio>
            </v-radio-group>
          </v-flex>
          <v-flex v-if="f_field.name=='sound' && this.value_new=='1'">
            <v-radio-group v-model="audio_bit" label="Audio Bit" row>
              <v-radio v-for="s in ['16 Bit','20 Bit','24 Bit']" :label="s" :value="s" :key="s" class="ml-3"></v-radio>
            </v-radio-group>
          </v-flex>
          <v-flex v-if="f_field.name=='sound' && this.value_new=='1'">
            <v-select :items="channels" item-value="id" item-text="name" label="Channels" class="ml-3"></v-select>
          </v-flex>
          <v-flex v-if="f_field.name=='sound' && this.value_new=='1'">
            <v-radio-group v-model="audio_specs" label="Audio Specs" row>
              <v-radio v-for="s in ['light optical tone','magnetic','digital','unknown','other']" :label="s" :value="s" :key="s" class="ml-3"></v-radio>
            </v-radio-group>
          </v-flex>
        </v-flex>
      </v-flex>

      <v-flex v-else-if="f_field.etype==='select'">
        <v-select solo
          v-model="value_new"
          :items="this.selection_items"
          :label="`${f_field.title}`"
          item-text="name"
          item-value="id"
          :append-outer-icon="f_field.addNew ? 'add' : ''"
          :preppend-icon="f_field.preicon"
          @click:append-outer="showAddForm"
          append-icon="remove"
          @click:append="removeField(f_field)"
          >
          <!-- <v-icon
            @click="addArtistForm = true"
          >plus</v-icon> -->
        </v-select>
        <!-- <v-btn slot="activator" @click="addArtistForm = true" color="grey lighten-2" small icon>
          <v-icon small>add</v-icon>
        </v-btn> -->
        <v-flex v-if="f_field.name=='classification_new_id' && this.value_new=='film'">
          <v-radio-group v-model="film_type" label="Select Film Type" row>
            <v-radio v-for="s in ['tape','film','digital born']" :label="s" :value="s" :key="s" class="ml-3"></v-radio>
          </v-radio-group>
        </v-flex>

        <v-flex v-if="f_field.name=='classification_new_id' && this.value_new=='inst'">
          <v-checkbox v-for="s in ['Objects','Sound','FilmVideoAV','Slide','ComputerProgramSoftwareFile','Performance','Light','Other']"
            v-model="instalation_includes"
            :key="s"
            :label="s"
            :value="s"
            hide-details
        ></v-checkbox>

        <v-flex v-if="this.instalation_includes.indexOf('FilmVideoAV')>=0">
          <v-radio-group v-model="film_type" label="Select Film Type" row>
            <v-radio v-for="s in ['tape','film','digital born']" :label="s" :value="s" :key="s" class="ml-3"></v-radio>
          </v-radio-group>
        </v-flex>

        </v-flex>
      </v-flex>

      <v-flex v-else-if="f_field.etype==='autocomplete'">
        <v-autocomplete solo
          v-model="value_new"
          :items="this.selection_items"
          :label="`${f_field.title}`"
          item-text="name"
          item-value="id"
          :chips="f_field.chips"
          :multiple="f_field.multiple"
          append-icon="remove"
          @click:append="removeField(f_field)"
          >
        </v-autocomplete>
      </v-flex>
      <v-flex v-if="this.showingAddForm && f_field.addNew">
        <add-artist v-if="f_field.table=='artists'" itemToAdd="f_field"></add-artist>
      </v-flex>
      <v-flex v-if="this.showingAddForm && f_field.addNew">
        <add-location v-if="f_field.table=='artwork_locations'" itemToAdd="f_field"></add-location>
      </v-flex>

    </div>
  </div>
</template>

<script>
import EditFieldHeader from '@/components/artists/EditFieldHeader'
import ViewArtworks from '@/components/artists/ViewArtworks'
// import dynamic_fields from '@/data/dynamic_fields'
import fields from '@/data/full_user_fields'
import AddArtist from '@/components/artists/AddArtist'
import AddLocation from '@/components/locations/AddLocation'
import Upload from '@/components/artworks/Upload'
import Location from '@/components/artworks/Location'
// import Films from '@/components/artworks/Films'
import Electrical from '@/components/artworks/Electrical'
// import EditField from './EditField'

function dynamicSort(property) {
  var sortOrder = 1;
  if(property[0] === "-") {
    sortOrder = -1;
    property = property.substr(1);
  }
  return function (a,b) {
    var result = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0;
    return result * sortOrder;
  }
}
function nl2br (str, is_xhtml) {
    var breakTag = (is_xhtml || typeof is_xhtml === 'undefined') ? '<br />' : '<br>'
    return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2')
}

export default {
  name: 'edit-field-sub',
  data () {
    return {
      channels: [
        {id: '1', value: '1', name: 'Single-channel'}, 
        {id: '2', value: '2', name: 'Two-channel'}, 
        {id: '3', value: '3', name: 'Three-channel'}, 
        {id: '4', value: '4', name: 'Four-channel'}, 
        {id: '5', value: '5', name: 'Five-channel'}, 
        {id: '6', value: '6', name: 'Six-channel'}, 
        {id: '7', value: '7', name: 'Seven-channel'}, 
        {id: '8', value: '8', name: 'Eight-channel'}, 
        {id: '9', value: '9', name: 'Nine-channel'}, 
        {id: '10', value: '10', name: 'Ten-channel'}, 
        {id: '11', value: '11', name: '11-channel'}, 
        {id: '12', value: '12', name: '12-channel'}, 
        {id: '13', value: '13', name: '13-channel'}, 
        {id: '14', value: '14', name: '14-channel'}, 
        {id: '15', value: '15', name: '15-channel'}, 
      ],
      count: 0,
      showingAddForm: false,
      showUpload: false,
      instalation_includes: [],
      film_type: '',
      isEditing: false,
      an_exists: false,
      saved: false,
      cannotSave: false,
      value_new: '',
      show: true,
      model: {},
      electrical: {
        monitor_specification: '',
        projector_specification: '',
        motor_specification: '',
        bulb_specification: '',
        switch: '',
        other: '',
        monitor_origin: '',
        projector_origin: '',
        motor_origin: '',
        bulb_origin: '',
        switch_origin: '',
        other_origin: '',
        interfaces: '',
        brand: '',
        sn: '',
        an: '',
        production_date: '',
        number_of_parts: '',
        power_requirement: '',
        height: '',
        width: '',
        depth: '',
        weight: '',
        specs: '',
        modification: '',
        periphals: '',
        associated_items: ''
      }
      // model: "artwork_location"
      // model: "artwork_location"
      // this.f_field.show
    }
  },
  props: ['field','artwork','placeholder', 'label', 'name', 'value','selection','title','reading_device','fields','film'],
  methods: {
    removeField(f) {
      // console.log(f)
      document.getElementById(f.name).style.display = 'none'
    },
    updateValue(f) {
      // console.log(f)
      this.$emit('input', {
        value: this.$refs[f].value,
        field: f
      })
    },
    showAddForm () {
      this.showingAddForm=!this.showingAddForm
    },
    add_field (field) {
      document.getElementById(field.name).style.display = 'block'
    },
    saveOrEdit (){
      this.isEditing=!this.isEditing
      this.$refs[this.f_field['name']].isFocused = true
      if (this.an_exists == false) {
        if (this.isEditing == false) {
          this.saved = true
          setTimeout(() => {
            this.saved = false
          }, 2000); 
        }
      } else {
        this.cannotSave = true
          setTimeout(() => {
            this.cannotSave = false
          }, 4000); 
      }
    },
    // nefunguje tak ako chcem
    format_date (date,format) {
      var moment = require('moment')
      var ndate = new Date(date)
      return moment(ndate).format(format)
    },
    check_an (value) {
      if (this.f_field.name == 'accession_number' && this.isEditing == true) {
        var a = Object.assign([],this.$store.state.artworks)
        var b = a.filter(aa => aa.accession_number == value)
        this.an_exists = b.length > 0
      }
    }
  },
  computed: {
    dynamic_field_list () {
      if (this.f_field.headline) {
        var c = []
        if (this.report || this.reading_device) {
          var fields2 = this.fields
        } else {
          var fields2 = fields['tabs'][this.$store.state.currentTab.substr(4)]['fields']
        }
        // var fields2 = fields['tabs'][this.$store.state.currentTab.substr(4)]['fields']
        c = fields2.filter(f => (f.dynamic && f.section === this.f_field.section))
        return c
      } else {
        return []
      }
    },

    field_type () {
      return (this.f_field.etype ? this.f_field.etype : this.f_field.ctype)
    },
    selection_items () {
      if (this.f_field.table) {
        if (this.f_field.table =='contacts') {
          var contacts = Object.assign([],this.$store.state.contacts)
          if (this.f_field.column) {
            return contacts.filter(c => c[this.f_field.column] == c[this.f_field.association])
          } else {
            return contacts
          }
        }
        if (this.f_field.table =='artists') {
          var artists = Object.assign([],this.$store.state.artists)
          if (this.f_field.column) {
            return artists.filter(c => c[this.f_field.column] == c[this.f_field.association])
          } else {
            return artists.sort(dynamicSort('name'))
          }
        }
        if (this.f_field.table == 'artwork_locations') {
          // console.log(this.f_field.table)
          // console.log('this.f_field.table')
          var artwork_locations = Object.assign([],this.$store.state.locations)
          if (this.f_field.column) {
            return artwork_locations.filter(c => c[this.f_field.column] == c[this.f_field.association])
          } else {
            return artwork_locations.sort(dynamicSort('name'))
          }
        }
      }
      if (this.f_field.selection && this.f_field.selection.length > 0) {
        return this.f_field.selection
      }
    },
    f_field () { 
      var f = this.field
      f.model_string_c = ''
      // console.log(this.field.model_string)
      // console.log(this.field.name)
      // console.log(this.electrical)
      f.model_string_c = this.field.model_string ? this.field.model_string+'.'+this.field.name : this.field.name
      // console.log(f.model_string_c)
      // console.log(f)
      f.column = this.field.column ? this.field.column : false
      // f.value_string = this.field.model_string ? this[this.field.model_string][this.field.name] : this.f_artwork[this.field.name]
      // f.value_string = f.value_string ? f.value_string : ''
      return f
    },
    f_artwork () { return this.artwork }
  },
  components: {AddLocation,AddArtist,EditFieldHeader,ViewArtworks,Upload,Location,Electrical}
  //Films,
}

</script>

<style scoped>
  li {list-style:none; margin: 15px 0;}
</style>



// WEBPACK FOOTER //
// src/components/artworks/EditFieldSub.vue